import { useMemo } from "react";

const formatProgress = (objective) => `${Math.min(objective.progress || 0, objective.target)}/${objective.target}`;

const EmptyState = ({ title, body }) => (
	<div className="daily-ops-empty">
		<strong>{title}</strong>
		<p>{body}</p>
	</div>
);

export function DailyOpsModal({ dayKey, daily, commandMarks, onClose, onClaim, busyRewardId = "" }) {
	const activeObjectives = daily?.activeObjectives || [];
	const loginReward = daily?.loginReward || null;

	const allOps = useMemo(() => {
		const loginCard = loginReward && !loginReward.claimed ? [{
			instanceId: "login",
			category: "Check-In",
			label: loginReward.label,
			description: loginReward.description,
			reward: loginReward.reward,
			progressLabel: "Ready",
			claimable: true,
			completed: true,
		}] : [];

		const activeCards = activeObjectives.map((objective) => ({
			instanceId: objective.instanceId,
			category: objective.kind === "chain" ? `${objective.category} T${objective.tier}` : objective.category,
			label: objective.label,
			description: objective.description,
			reward: objective.reward,
			progressLabel: objective.completed ? "Ready" : formatProgress(objective),
			claimable: objective.completed && !objective.claimed,
			completed: objective.completed,
		}));

		return [...loginCard, ...activeCards];
	}, [activeObjectives, loginReward]);

	return (
		<div className="daily-ops-modal" role="dialog" aria-modal="true" aria-label="Daily Ops">
			<div className="daily-ops-modal__scrim" onClick={onClose} />
			<section className="daily-ops-modal__panel panel">
				<div className="daily-ops-header">
					<div className="daily-ops-header__title">
						<div className="eyebrow">Daily Ops</div>
						<h2>{dayKey}</h2>
					</div>
					<div className="daily-ops-bank" aria-label={`Command Marks ${commandMarks}`}>
						<small>Command Marks</small>
						<strong>{commandMarks}</strong>
					</div>
					<button type="button" className="button button--ghost" onClick={onClose}>Close</button>
				</div>

				<div className="daily-ops-brief">
					<div>
						<small>Login Streak</small>
						<strong>{daily?.loginStreak || 1}</strong>
					</div>
					<div>
						<small>Ready To Claim</small>
						<strong>{allOps.filter((objective) => objective.claimable).length}</strong>
					</div>
					<div>
						<small>Ops Available</small>
						<strong>{allOps.length}</strong>
					</div>
					<div>
						<small>Ops Completed</small>
						<strong>{daily?.completedObjectives?.length || 0}</strong>
					</div>
				</div>

				<div className="daily-ops-scroll">
					<div className="daily-ops-list">
						{allOps.length ? allOps.map((objective) => (
							<article key={objective.instanceId} className={`daily-op-card ${objective.completed ? "daily-op-card--completed" : ""}`}>
								<div className="daily-op-card__meta">
									<span>{objective.category}</span>
									<strong>{objective.label}</strong>
									{objective.description ? <p>{objective.description}</p> : null}
									<small>{objective.progressLabel} - Reward {objective.reward} marks</small>
								</div>
								{objective.claimable ? (
									<button
										type="button"
										className="button button--success"
										onClick={() => onClaim(objective.instanceId)}
										disabled={busyRewardId === objective.instanceId}
									>
										{busyRewardId === objective.instanceId ? "Claiming..." : "Claim"}
									</button>
								) : (
									<div className="daily-op-card__progress">{objective.progressLabel}</div>
								)}
							</article>
						)) : (
							<EmptyState title="No Daily Ops loaded" body="Open the board again after the daily profile sync finishes." />
						)}
					</div>
				</div>
			</section>
		</div>
	);
}
